import { inheritActionOwner, isActionCurrent } from '@/_core/fluxstore/dispatchOwnership';
import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { AddNewTask, SaveNewTask } from '..';
import { createDebugger } from '@/_core/utils/debug';

const debug = createDebugger('pages:main:storymap:store:actions:newCard:addTaskFromAi');

const { registerMiddleware, dispatch } = useStorymapStore();

export class AddTaskFromAi extends Action<StorymapState> {
    public static ACTION_TYPE = 'AddTaskFromAi';
    public _cardId: string;

    public constructor(public activityId: string, public title: string) {
        super(AddTaskFromAi.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: AddTaskFromAi): Promise<boolean> => {
    debug('AddTaskFromAi start', action);

    const order = state.tasks.filter((x) => x.activityId === action.activityId).length;

    const addAction = inheritActionOwner(action, new AddNewTask(action.activityId, order, true));
    await dispatch(addAction);
    if (!isActionCurrent(action)) return false;
    action._cardId = addAction._cardId;
    await dispatch(inheritActionOwner(action, new SaveNewTask(action._cardId, action.title)));
    if (!isActionCurrent(action)) return false;

    debug('AddTaskFromAi end', action);

    return true;
};

//@ts-ignore
registerMiddleware(AddTaskFromAi.ACTION_TYPE, middleware);
